import { Button, Modal } from '../../../../components'
import { useAppDispatch } from '../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { deleteEmpFile } from '../../api'
import { DelEmployeeFileProps } from '../../types'
import { deleteEmployeeFile } from '../../slice/employeeFileSlice'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'

const DelEmpFile = ({ show, onClose, data }: DelEmployeeFileProps) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Delete Employee File"
            body={
                <>
                    <p className="del-desc">
                        Are you sure you want to delete this Employee File ?
                    </p>
                    <div className="footer-block">
                        <Button
                            type="submit"
                            onClick={async () => {
                                dispatch(SHOW_LOADER())
                                const response = await deleteEmpFile(data.id)
                                if (response) {
                                    dispatch(
                                        deleteEmployeeFile({
                                            id: data.id,
                                        })
                                    )
                                    dispatch(
                                        SHOW_NOTIFICATION({
                                            type: 'success',
                                            message:
                                                'Employee File deleted successfully',
                                        })
                                    )
                                }
                                dispatch(HIDE_LOADER())
                                onClose(false)
                            }}
                        >
                            YES
                        </Button>
                        <Button
                            type="submit"
                            variant="outline-success"
                            onClick={() => onClose(false)}
                        >
                            NO
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default DelEmpFile
